import { IMediaAndContent } from '../../interfaces/MediaAndContent';
import DateWithIcon from '../Common/DateWithIcon';
import ChipsMapper from '../Mappers/ChipsMapper';

const { REACT_APP_BACKOFFICE_CONNECTION, REACT_APP_BACKOFFICE_FILE_UPLOAD_PATH } = process.env;

type MediaAndContentMiniVariant = 'default' | 'brand';

interface MediaAndContentMiniVariantStyles {
  border: string;
  rounded: string;
  bg: string;
  imgBorder: string;
  paddingTextBlock: string;
  hover: string;
}

const cardVariantStyles: Record<MediaAndContentMiniVariant, MediaAndContentMiniVariantStyles> = {
  default: {
    border: 'border border-system-light-20',
    rounded: 'rounded-[12px]',
    bg: 'bg-system-light-10',
    imgBorder: 'rounded-t-lg border border-system-light-20',
    paddingTextBlock: 'p-4',
    hover: 'hover:shadow-custom-dual transition-shadow duration-200'
  },
  brand: {
    border: 'none',
    rounded: '',
    bg: 'transparent',
    imgBorder: 'rounded-sm',
    paddingTextBlock: 'p-0 pt-4',
    hover: 'hover:opacity-80 transition-opacity duration-200'
  },
};

interface IMediaAndContentMiniProps extends IMediaAndContent {
  variant?: MediaAndContentMiniVariant;
  fluid?: boolean;
}

const MediaAndContentMini = ({
  imagen,
  titulo,
  descripcion,
  fecha,
  categorias,
  variant = 'default',
  fluid = false,
}: IMediaAndContentMiniProps) => {
  const styles = cardVariantStyles[variant];

  const cardWidth = fluid ? 'w-full' : 'w-[18.625rem] sm:w-[22.5rem]';
  const imgWidth = fluid ? 'w-full' : 'w-[18.625rem] sm:w-[22.5rem]';
  const imgHeight = fluid ? 'h-[11.549rem] sm:h-[18.803rem] md:h-[14.665rem] lg:h-[15.07rem] xl:h-[12.6875rem]' : 'h-[12.6875rem]';
  const textBlockWidth = fluid ? 'w-full' : 'w-[18.625rem] sm:w-[22.5rem]';
  const textBlockHeight = fluid ? 'h-fit' : 'h-full min-h-[14.125rem]';

  return (
    <div className={`${cardWidth} ${fluid ? 'h-full' : ''} ${styles.rounded} ${styles.bg} cursor-pointer ${styles.hover} group`}>
      <div className={`overflow-hidden rounded-sm ${imgWidth} ${imgHeight} ${styles.imgBorder}`}>
        <img
          src={`${REACT_APP_BACKOFFICE_CONNECTION}${REACT_APP_BACKOFFICE_FILE_UPLOAD_PATH}${imagen.replace("files/", "")}`}
          alt={imagen.replace("files/", "")}
          className={`object-cover h-full w-full transition-transform duration-500 ease-[cubic-bezier(0.2,0,0,1)] group-hover:scale-110`}
        />
      </div>
      <div className={`${styles.paddingTextBlock} flex flex-col gap-2 ${styles.bg} rounded-b-lg ${textBlockHeight} ${textBlockWidth} ${styles.border}`}>
        <h4 className='text-tlarge text-sistem-light-100 line-clamp-3'>{titulo}</h4>
        <ChipsMapper categorias={categorias} />
        <p className='text-bmedium text-sistem-light-100 line-clamp-3'>{descripcion}</p>
        <DateWithIcon date={fecha} />
      </div>
    </div>
  );
};

export default MediaAndContentMini;